// When the chat adds a travel task in front of a meeting it has just booked (SuperAideyChat).
// Settings → Travel preferences has "Automatically create travel tasks for in-person meetings";
// this is the one place that decides, so the switch and the chat cannot disagree.
export function shouldAutoCreateTravelTask(details, travelPrefs) {
  if (travelPrefs && travelPrefs.autoCreateTravelTasks === false) return false;   // the switch, off
  return !!(details && details.meetingMode === 'in person' && details.location && !details.noTravel);
}
